<template>
    <div class="mt-3 mb-3 tutorial-block">
        <b-card no-body>
            <b-tabs card>
                <b-tab v-for="game in games"
                v-if="game.version === 2"
                :key="game.id" :title="game.name | lang('titles')" @click="sync"
                :active="activeGameId == game.id">
                    <b-card-text>
                        <component v-bind:is="'game_'+game.name" :game="game"></component>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import game_5_36 from '@tv/components/partials/tutorials/5_36';
    import game_7_42 from '@tv/components/partials/tutorials/7_42';
    import game_Interjackpot from '@tv/components/partials/tutorials/Interjackpot';
    import game_Jokerjackpot from '@tv/components/partials/tutorials/Jokerjackpot';
    import game_Dice from '@tv/components/partials/tutorials/Dice';
    import { syncFrameHeight } from "@tv/helpers";

    export default {
    components: {game_5_36, game_7_42, game_Interjackpot, game_Jokerjackpot, game_Dice},
        data() {
            return {
                activeGameId: this.$route.params.gameId || Config.game_id,
            };
        },
        methods: {
            sync() {
                this.$nextTick(() => syncFrameHeight());
            }
        },
        computed: {
            games() {
                return Config.games;
            },
        },
        mounted() {
            this.$nextTick(() => syncFrameHeight());
        }
    }
</script>